import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import { onChange } from '../../../common/actions';
import { getKey, clientMessage } from '../../../utils/common';
import CONSTANT, { CACHE } from '../../../utils/constants';

class Details extends Component {
  constructor(props) {
    super(props);
    this.label = clientMessage(CONSTANT.SUBSCRIPTION.toLowerCase(), this.props.cache).label;
  }

  merchantTitle() {
    let merchantDetails;
    let title = '';
    const merchantConfig = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
    if (typeof this.props.cache.getData(CACHE.PAYMENT_OPTIONS) === 'object') {
      const paymentOptions = this.props.cache.getData(CACHE.PAYMENT_OPTIONS);
      merchantDetails = paymentOptions.merchantDetails;
      const merchantName = getKey(merchantConfig, 'merchant.name', null);
      if (merchantName) {
        merchantDetails.merchantName = merchantName;
      }
    }
    getKey(merchantDetails, 'merchantName') &&
      (title = `( ${this.label.sharedBy} ${merchantDetails.merchantName} )`);
    return title;
  }

  closeOverlayWrap = () => {
    this.props.onHelperOverlayToggle('');
  };

  render({ subscription }, {}) {
    return (
      <section className={`ptm-subsDetails`}>
        <div className={`ptm-close-wrap ptm-pos-a closeIcon`} onClick={this.closeOverlayWrap}>
          <span className={`ptm-cross ptm-pos-r`} />
        </div>
        <div className={`ptm-s-title ptm-txtcolor`}>{this.label.details}</div>
        <p className={`ptm-extend-txt ptm-txtcolor`}>{this.merchantTitle()}</p>
        {subscription && subscription.details && (
          <div>
            {subscription.subsType === CONSTANT.SUBS_TYPE.VARIABLE && (
              <p className={`ptm-sub-upto ptm-body-color`}>{this.label.upto}</p>
            )}
            {subscription.details.frequencyKey && (
              <p class={`ptm-sub-tip-text ptm-txtcolor`}>
                {subscription.details.frequencyKey}
                <span className="ptm-right ptm-txtcolor">{`₹${subscription.details.frequencyValue}`}</span>
              </p>
            )}
            {subscription.details.nextPaymentKey && (
              <p class={`ptm-sub-tip-text ptm-txtcolor`}>
                {subscription.details.nextPaymentKey}
                <span className="ptm-right ptm-txtcolor">
                  {subscription.details.nextPaymentValue}
                </span>
              </p>
            )}
          </div>
        )}
      </section>
    );
  }
}

export default connect(
  'subscription, cache',
  onChange
)(Details);



// WEBPACK FOOTER //
// ./components/subscription/details/index.js